import loadable from '@loadable/component';

export const BannerEdit = loadable(
  () => import(/* webpackChunkName: "redturtle__qubicaamf-theme" */ './Edit'),
);
